(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["boot-base-portlet"] = factory();
	else
		root["boot-base-portlet"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(164);


/***/ }),

/***/ 164:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Created by Carsten Bühler
	 * User: c.buehler on 23.11.2016
	 * Copyright: xdot GmbH 2015
	 */
	
	var _config = { paths: {
	        'named-props': '/api/jsonws/base.namedprop/list-all/-expand?p_auth=' + Liferay.authToken,
	        'group-schemas': '/api/jsonws/base.groupschema/list-group-schemas/group-id/' + Liferay.ThemeDisplay.getScopeGroupId() + '?p_auth=' + Liferay.authToken,
	        'initial-named-lists': '/api/jsonws/administration.namedlist/list-viewable-by-group-scope/?p_auth=' + Liferay.authToken
	    }
	};
	window['req' + 'uire'].config(_config);
	
	window['req' + 'uire'](['base-portlet/js/base-portlet'], function () {
	    console.info('Initial load of plugins done');
	}, function (err) {
	    console.error('Initial load of plugins: ', err.requireModules, ' fail', err);
	    if (!Liferay.ThemeDisplay.isSignedIn()) {
	        throw new Error('Not signedIn!');
	    }
	});

/***/ })

/******/ })
});
;


// WEBPACK FOOTER //
// boot-base-portlet.js